// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import ManagerAvatar from '../../assets/manager-avatar.png'
import S from './style';
import moment from 'moment';
import { SupportMessageType } from '../../../../types/Model';
import { PopupPreviewProps } from '../Popup/Popup';
interface MassageProps {
  time: Date;
  message: string;
  username: string;
  currentId: number;
  imagesUrls?: string[];
  updateSupportStatus: (id: number) => void;
  messageType?: SupportMessageType;
  isStatusClosed: boolean;
  setShowPreview: React.Dispatch<React.SetStateAction<{
    time: string;
    message: string;
    username: string;
    imagesUrls: string[];
    currentPhotoId: number;
  } | undefined>>
}
const ManagerMessage = (props: MassageProps): JSX.Element => {
  const intl = useIntl();
  const now = new Date().getTime();
  const { time, username, imagesUrls = [], message, updateSupportStatus, currentId, messageType, isStatusClosed, setShowPreview } = props;
  const updateStatus = () => {
    updateSupportStatus(currentId)
  }
  const setPreview = (index: number) => {
    setShowPreview({
      username,
      time: now - time.getTime() <= 86400000 ? `${moment(time).fromNow(true)}` + intl.formatMessage({ id: 'I026' }) : moment(time).format('L'),
      imagesUrls,
      message,
      currentPhotoId: index
    })
  }
  return (
    <>
      <S.MessageWrapper >
        <S.Avatar src={ManagerAvatar} />
        <S.Message>
          <S.Name>
            {username}
          </S.Name>
          <S.MessageText>
            {messageType === SupportMessageType.Resolve ? intl.formatMessage({ id: 'I025' }) : message}
          </S.MessageText>
          {messageType === SupportMessageType.Resolve ? <S.Button
            onClick={updateStatus}
            disabled={isStatusClosed}
          >
            <FormattedMessage id="I024" />
          </S.Button> : ''}
          {imagesUrls && <S.MessageImages>
            {imagesUrls.map((data, index) => {
              return (
                <S.ImageItemContainer key={index} >
                  <S.Image src={data} onClick={() => setPreview(index)} />
                </S.ImageItemContainer>
              )
            })}
          </S.MessageImages>
          }
          <S.Time>
            {now - time.getTime() <= 86400000 ? `${moment(time).fromNow(true)}` + intl.formatMessage({ id: 'I026' }) : moment(time).format('L')}
          </S.Time>
        </S.Message>
      </S.MessageWrapper>
    </>
  );
}

export { ManagerMessage as default }
